module.exports = __webpack_public_path__ + "img/img121.0033ec85.svg";